/**
 * Wire-format codec for the `order` URL param.
 *
 * The `order` param is encoded as `<field>:<direction>`, e.g. `updatedAt:desc`.
 * Direction must be `'asc'` or `'desc'`. Any other format is treated as invalid
 * and returns `null` from `parseOrder`.
 */

export type OrderDirection = 'asc' | 'desc'

/** A [field, direction] tuple matching the Scrivito DataClass transform shape. */
export type Order = [string, OrderDirection]

/**
 * Parse an `order` URL param string into an `Order` tuple.
 * Returns `null` for any invalid input (null, empty, wrong separator, bad direction).
 */
export const parseOrder = (raw: string | null | undefined): Order | null => {
  if (!raw) {
    return null
  }
  const colonIndex = raw.indexOf(':')
  if (colonIndex <= 0) {
    return null
  }
  const field = raw.substring(0, colonIndex)
  const direction = raw.substring(colonIndex + 1)
  if (direction !== 'asc' && direction !== 'desc') {
    return null
  }
  return [field, direction]
}

/**
 * Serialize an `Order` tuple to a URL param string.
 */
export const serializeOrder = (order: Order): string =>
  `${order[0]}:${order[1]}`
